import { Box, Button, Icon, IconButton, Paragraph } from '@zillow/constellation-10';
import { IconCloseFilled } from '@zillow/constellation-icons';
import AttachmentGuidelinesBody from '../AttachmentGuidelines/AttachmentGuidelinesBody';

type AttachmentGuidelinesInlineProps = {
  onClose(): void;
  onContinue(): void;
};

export default function AttachmentGuidelinesInline({ onClose, onContinue }: AttachmentGuidelinesInlineProps) {
  return (
    <Box
      css={{
        position: 'absolute',
        inset: 0,
        zIndex: 'modal',
        padding: 'default',
        background: 'bg.neutral',
        overflow: 'hidden',
      }}
    >
      <Box
        css={{
          display: 'flex',
          flexDirection: 'column',
          height: '100%',
          borderStyle: 'dashed',
          borderWidth: '2px',
          borderColor: 'border.subtle',
          padding: 'default',
          overflow: 'auto',
        }}
      >
        <Box css={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 'default' }}>
          <Paragraph textStyle="body-sm-bold">Attachment guidelines</Paragraph>
          <IconButton
            shape="circle"
            emphasis="bare"
            tone="neutral"
            icon={<Icon css={{ color: 'icon.muted' }} render={<IconCloseFilled />} />}
            onClick={onClose}
            size="sm"
            title="Close"
          />
        </Box>

        <AttachmentGuidelinesBody variant="compact" />

        <Button
          emphasis="filled"
          onClick={onContinue}
          tone="brand"
          data-testid="continue-button"
          css={{ marginTop: 'default', width: '100%' }}
        >
          Continue
        </Button>
      </Box>
    </Box>
  );
}
